import React, { memo } from "react";
import PropTypes from "prop-types";
import Image from "../../components/Image";
import "../../styles/index.scss";

const ClientLogos = ({ clientLogos }) => {
  return (
    <div className="row justify-flex-start marquee home-marquee">
      {clientLogos?.map(({ id, alt, src, width, height }) => (
        <span key={id}>
          <Image src={src} alt={alt} width={width} height={height} />
        </span>
      ))}
    </div>
  );
};

ClientLogos.defaultProps = {
  clientLogos: [],
};
ClientLogos.propTypes = {
  clientLogos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
      width: PropTypes.string,
      height: PropTypes.string,
    }),
  ),
};

export default memo(ClientLogos);
